import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import ReactGA from 'react-ga';
import loadable from '@loadable/component';
import { History } from 'history';
import { Store } from 'redux';

import ToastWrapper from '@shared/wrappers/toast/ToastWrapper';
import Routes from './domain/router/routes.constants';
import '@shared/translation/weglot/styles.css';

const Auth = loadable(() => import('./domain/auth'));
const PaymentSuccessPage = loadable(() => import('./domain/_screens/sign-up/components/PaymentSuccessPage'));
const TrialExpired = loadable(() => import('./domain/billing/trial-expired/trial-expired'));
const PolicyServiceAndServiceTermsContainer = loadable(() => import('./domain/_screens/sign-up/PolicyServiceAndServiceTerms.page'));
const AppInternalRoutes = loadable(() => import('./platform-internal-routes-app'));

interface PlatformAppProps {
    history: History;
    store: Store;
}

const PlatformApp = ({ history, store }: PlatformAppProps) => {
    useEffect(() => {
        ReactGA.pageview(window.location.pathname);
    }, []);

    return (
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <Switch>
                    <Redirect
                        from={`/auth${Routes.POLICY_PRIVACY_AND_SERVICE_TERMS}`}
                        to={Routes.POLICY_PRIVACY_AND_SERVICE_TERMS}
                    />
                    <Route path={Routes.AUTH} component={Auth} />
                    <Route path={Routes.SUCCESS} component={PaymentSuccessPage} />
                    <Route path={Routes.WAITING_LIST} component={TrialExpired} />
                    <Route
                        path={Routes.POLICY_PRIVACY_AND_SERVICE_TERMS}
                        component={PolicyServiceAndServiceTermsContainer}
                    />
                    <Route
                        exact
                        path={Routes.LOGIN}
                        render={() => <Redirect to={Routes.AUTH_SIGN_IN} />}
                    />
                    <Route
                        path="/"
                        component={AppInternalRoutes}
                    />
                </Switch>
            </ConnectedRouter>
            <ToastWrapper />
        </Provider>
    );
};

export default PlatformApp;
